import { Typography, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";

const BgText = ({ children }) => {
  const isMd = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  
  return (
    <>
      {isMd && (
        <Typography
          component={motion.p}
          sx={{
            position: "absolute",
            top: -40,      // Move to top
            right: -20,
            fontFamily: "Outfit, sans-serif",
            fontWeight: 900,
            cursor: "default",
            userSelect: "none",
            color: "white",
            opacity: 0.03,
            lineHeight: "0.8",
            zIndex: -1,
            fontSize: "18rem",
            whiteSpace: 'nowrap'
          }}
        >
          {children}
        </Typography>
      )}
    </>
  );
};

export default BgText;
